import { createContext, useContext, useState } from 'react';

const WorkoutSessionContext = createContext(null);

export function WorkoutSessionProvider({ children }) {
  const [activeSessionData, setActiveSessionData] = useState(null);
  return (
    <WorkoutSessionContext.Provider value={{ activeSessionData, setActiveSessionData }}>
      {children}
    </WorkoutSessionContext.Provider>
  );
}

export function useWorkoutSession() {
  return useContext(WorkoutSessionContext);
}
